import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Box, CardMedia, Button, Typography } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { PAGES } from "../../consts/pages";

import { View } from "../../components/View";
import { QuantumTextIcon } from "../../components/Icons";
import logoPhoto from "../../assets/png/logo.png";
import backgroundPhoto from "../../assets/jpg/homeBackground.jpg";
import { palette } from "../../theme/palette";
import { getUserMetadata } from "../../reducers/ownUser/selectors";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
    width: "100dvw",
  },
  content: {
    position: "relative",
    display: "flex",
    width: "35%",
    height: "100%",
    flexDirection: "column",
    backgroundColor: palette.typography.black.high,
    alignItems: "center",
    paddingTop: "4rem",
    gap: "10rem",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
  line: {
    height: "20px",
    width: "4px",
    background: palette.black,
    border: "none",
    marginRight: "-3px",
  },
  subheader: {
    alignSelf: "center",
    color: palette.translucentWhite,
    fontWeight: "bold",
    fontStyle: "italic",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    alignItems: "center",
    width: "100%",
  },
  button: {
    backgroundColor: palette.black,
    color: palette.lightGrey,
    fontWeight: "500",
    cursor: "pointer",
    border: "1px solid",
    lineHeight: "100px",
    padding: "20px 30px",
    width: "160px",
    "&:hover": {
      background: palette.dpdRedTranslucent,
    },
  },
  background: {
    width: "100%",
    height: "100%",
  },
  errorBox: {
    background: palette.white,
    padding: "10px",
    margin: "10px",
    borderRadius: "5px",
  },
  error: {
    color: "red",
  },
}));

const HomePage = () => {
  const styles = useStyles();
  const userMetadata = useSelector(getUserMetadata);

  useEffect(() => {
    document.title = "Quantum Management";
  }, []);

  const hasRequiredRole = (requiredRole) =>
    userMetadata?.roles && userMetadata.roles.includes(requiredRole);

  const HomeIcon = () => {
    return (
      <Box className={styles.logoContainer}>
        <img src={logoPhoto} alt="dpd logo" />
        <hr className={styles.line} />
        <QuantumTextIcon />
      </Box>
    );
  };

  return (
    <View className={styles.container}>
      <View className={styles.content}>
        <HomeIcon />
        <Box className={styles.buttonContainer}>
          <Typography className={styles.subheader}>Services</Typography>
          {PAGES.filter(({ pageName }) => !!pageName).map(
            ({ pageName, path, requiredRole }) => (
              <Button
                key={`${pageName}-${path}`}
                className={styles.button}
                component={Link}
                to={path}
                disabled={requiredRole && !hasRequiredRole(requiredRole)}
              >
                {pageName}
              </Button>
            )
          )}
        </Box>
      </View>
      <Box width={1}>
        <CardMedia className={styles.background} image={backgroundPhoto} />
      </Box>
    </View>
  );
};

export default HomePage;
